import type { CustomIconProps } from '../types';

export default function EvaporativeCoolerIcon({ size = 24, className, strokeWidth }: CustomIconProps) {
  const stroke = (strokeWidth ?? 2) * 2;
  return (
    <svg width={size} height={size} viewBox="2 2 44 44" fill="none" className={className}>
      <g stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round">
        <rect x="7" y="4.5" width="34" height="39" rx="3" />
        {/* Grille slats — thinned from 16 lines to 8 so they read as vents
            instead of merging into a solid block at small sizes. */}
        <path d="M11.5 15h7" />
        <path d="M11.5 23h7" />
        <path d="M11.5 31h7" />
        <path d="M29.5 15h7" />
        <path d="M29.5 23h7" />
        <path d="M29.5 31h7" />
        <path d="M21 23h6" />
        <path d="M21 31h6" />
        <path d="M24 11.5s-2.25 2.4-2.25 4a2.25 2.25 0 0 0 4.5 0c0-1.6-2.25-4-2.25-4Z" />
        <path d="M10 38h28" />
      </g>
    </svg>
  );
}
